import {
  addDoc,
  collection,
  serverTimestamp,
  setDoc,
  doc,
} from "firebase/firestore";
import { db } from "./firebase";

export const writeUserProfile = (user) =>
  setDoc(
    doc(db, "users", user.uid),
    {
      uid: user.uid,
      email: user.email || "",
      displayName: user.displayName || user.email?.split("@")[0] || "User",
      lastLoginAt: serverTimestamp(),
    },
    { merge: true }
  );

export const writeAuditLog = ({
  action,
  entityType,
  entityId,
  entityTitle = "",
  changes = {},
  user,
}) =>
  addDoc(collection(db, "auditLogs"), {
    action,
    entityType,
    entityId: String(entityId),
    entityTitle,
    changes,
    userId: user?.uid || "unknown",
    userEmail: user?.email || "unknown",
    userName: user?.displayName || user?.email || "Unknown user",
    timestamp: serverTimestamp(),
  });
